const _ = require('underscore');
const Q = require('q');
const assignmentService = require('services/assignmentService');
const model = require('model/model');

const getNotifications = () => {
	let userContext = model.get('userContext');

	if (!userContext) {
		return Q({});
	}

	let cc = userContext.classCode;
	return assignmentService.getNewGradedAssignments({ cc }).then(resp => {
		let notifs = {};
		if (resp && resp.a && resp.a[cc]) {
			notifs = resp.a[cc];
		}
		model.set('studentNotifications', notifs);
		return notifs;
	});
};

const readNotification = aid => {
	return assignmentService.viewGradedAssignment({ aid }).then(resp => {
		let notifs = model.get('studentNotifications') || {};
		notifs = _.assign({}, notifs, {
			[aid]: false
		});
		model.set('studentNotifications', notifs);
		return notifs;
	});
};

model.change('userContext', function (uc) {
	model.remove('studentNotifications');
});

module.exports = {
	getNotifications,
	readNotification
};
